import type { SpectralLineData } from "../types";

export function normalize(lines: SpectralLineData[]): SpectralLineData[] {
  if (lines.length === 0) return lines;
  let max = 0;
  for (const l of lines) if (l.intensity > max) max = l.intensity;
  if (max === 0) return [];
  for (const l of lines) l.intensity /= max;
  return lines;
}
